(() => {
  const minimumQueryLength = 3;
  const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  const formatPrice = (value) => currency.format(Number.parseFloat(value) || 0);

  document.querySelectorAll('[data-hana-predictive-search]').forEach((form) => {
    const input = form.querySelector('input[type="search"]');
    const results = form.querySelector('[data-hana-predictive-results]');
    if (!input || !results) return;

    let controller;
    let timer;

    const clearResults = () => {
      results.replaceChildren();
      results.hidden = true;
    };

    const showMessage = (message) => {
      results.replaceChildren();
      const item = document.createElement('span');
      item.className = 'hana-rebuild-header__predictive-empty';
      item.textContent = message;
      results.append(item);
      results.hidden = false;
    };

    const showProducts = (products) => {
      results.replaceChildren();
      if (!products.length) {
        showMessage('Nenhum produto encontrado.');
        return;
      }

      products.forEach((product) => {
        const item = document.createElement('a');
        item.className = 'hana-rebuild-header__predictive-result';
        item.href = product.url;

        if (product.image) {
          const image = document.createElement('img');
          image.alt = product.title || '';
          image.height = 96;
          image.loading = 'lazy';
          image.src = product.image;
          image.width = 96;
          item.append(image);
        } else {
          item.append(document.createElement('span'));
        }

        const title = document.createElement('span');
        title.className = 'hana-rebuild-header__predictive-result-title';
        title.textContent = product.title || 'Produto Hana Beauty';
        item.append(title);

        const price = document.createElement('span');
        price.className = 'hana-rebuild-header__predictive-result-price';
        price.textContent = formatPrice(product.price);
        item.append(price);
        results.append(item);
      });
      results.hidden = false;
    };

    const search = async () => {
      const query = input.value.trim();
      if (query.length < 3) {
        controller?.abort();
        clearResults();
        return;
      }

      controller?.abort();
      controller = new AbortController();
      showMessage('Buscando produtos…');

      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`, { signal: controller.signal });
        if (!response.ok) throw new Error('Predictive search request failed');
        const data = await response.json();
        showProducts(data?.resources?.results?.products || []);
      } catch (error) {
        if (error.name !== 'AbortError') clearResults();
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(search, 220);
    });
    input.addEventListener('focus', () => {
      if (input.value.trim().length >= minimumQueryLength) search();
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') clearResults();
    });
    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) clearResults();
    });
  });
})();
